import { render, staticRenderFns } from "./CalendarText.vue?vue&type=template&id=d041dada&scoped=true&"
import script from "./CalendarText.vue?vue&type=script&lang=js&"
export * from "./CalendarText.vue?vue&type=script&lang=js&"
import style0 from "./CalendarText.vue?vue&type=style&index=0&id=d041dada&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d041dada",
  null
  
)

export default component.exports